import { render, staticRenderFns } from "./CabinetManagement.vue?vue&type=template&id=843ae0aa"
import script from "./CabinetManagement.vue?vue&type=script&lang=js"
export * from "./CabinetManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports